
import React, { Fragment } from 'react';

// Components

import ModalHeader from '../headers/ModalHeader';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';



const ResubmitModal = props => {
    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal:{
            modalData: {
                resubmitAction
            }
        },
        bottomAnchors: [
            anchor_1
        ],
        boundAnchor
    } = props;

    const handleResubmitClick = () => {
        hideModal();
        resubmitAction();
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head'>
                <ModalHeader { ...{ ...modalHeaderProps }} />
            </div>
            <div className = 'gi-modal__body'>
                <p>
                    <FormattedMessage id = 'modals.request_error.should_resubmit'/>
                </p>
            </div>
            <div className = 'gi-modal__controls'>
                <Button
                    className = 'usa-button gi-button gi-button__secondary'
                    onClick = { hideModal }
                >
                    <FormattedMessage id = 'button.close'/>
                </Button>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { handleResubmitClick }
                    inputRef = { boundAnchor(anchor_1) }
                >
                    <FormattedMessage id = 'button.resubmit'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default ResubmitModal;